import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trainer } from "../../Data";
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import Footer from "../../Component/Footer/Footer";
import ScrollRevealSection from "../../Component/Animation/scrollRevealSection";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import SupportIcon from "@mui/icons-material/Support";
import "./Home.css";
//import { useFetchContentQuery } from "../../Redux/Api/ContentApi";
import Splash from "../../Component/Splash/Splash";
import { Helmet } from "react-helmet-async";
import { useFetchAllContentQuery, useGetBlogQuery } from "../../Redux/Api/AuthApi";

const Home = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [allData,setAllData] = useState()
  const [contentData, setContentData] = useState(null);
  const [counterValues, setCounterValues] = useState({
    students: 70,
    classes: 5,
    coaches: 4,
    years: 8
  });

  const { data, isLoading, isSuccess} = useFetchAllContentQuery();

  useEffect(() => {
    if (isSuccess) {
      setContentData(data);
    }
  }, [data, isSuccess]);

  
  
    const response = useGetBlogQuery()
  
    console.log(response?.data)
  
    useEffect(()=>{
      if(response?.isSuccess){
        setAllData(response?.data)
      }
    },[response?.isSuccess,setAllData,response?.data])


  if (isLoading) {
    return <Splash />;
  }

  const features = [
    { icon: <SelfImprovementIcon />, title: "Encourage Self Discovery", delay: 0.1 },
    { icon: <TrendingUpIcon />, title: "Change Their Life", delay: 0.2 },
    { icon: <StackedLineChartIcon />, title: "Bring Out Their Best", delay: 0.3 },
    { icon: <SupportIcon />, title: "Help Them Meet Their Goals", delay: 0.4 }
  ];



  const comments = [
    {
      text: "KIGA has truly transformed my child's confidence and focus. The discipline and joy they bring into each class is amazing.",
      author: "John Kelly",
      role: "Parent of a 9-year-old student"
    },
    {
      text: "I've seen my daughter grow stronger—not just physically, but mentally. KIGA is more than a gym, it's a second home.",
      author: "Jeannet Shannod",
      role: "Parent of a young gymnast"
    },
    {
      text: "KIGA has been an excellent partner in promoting physical education and discipline among our students. Their professionalism and care stand out.",
      author: "Joyce",
      role: "School Principle"
    }
  ];
const getClassLevel = (name) => {
  if (!name) return "Intermediate";
  
  const lowerName = name.toLowerCase();
  
  if (lowerName.includes("beginner") || lowerName.startsWith("b")) {
    return "Entry Level";
  }
  if (lowerName.includes("advanced") || lowerName.includes("pre-team")) {
    return "Advanced";
  }
  if (lowerName.includes("intermediate") || lowerName.startsWith("i")) {
    return "Intermediate";
  }
  
  return "Intermediate";
};
  return (
    <>
    <Helmet>
     <title>Home</title>
     <meta
     name="description"
     content="Kigali International Gymnastics Academy, we believe in the power of discipline, creativity, and perseverance. Founded with a passion for acrobatics and gymnastics arts, our academy is dedicated to training and inspiring the next generation of gymnasts and young athletes. 
    "/>
    <link rel="canonical" href="/"/>
    </Helmet>
    <div className="kiga-home-main">
      {/* Hero Section */}
      <header 
        className="kiga-home-hero-section"
        style={{
          background: `linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4)), url('/images/Gallery/bac1.jpg')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <nav className="kiga-home-navbar">
          <div className="kiga-home-nav-logo">
            <Link to="/">
              <img src="/images/logo.jpg" alt="KIGA Logo" />
            </Link>
          </div>
          
          <div className="kiga-home-nav-links">
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/classes">Classes</Link>
            <Link to="/portal/booking">Booking</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/news">News</Link>
            <Link to="/contact">Contact</Link>
          </div>
          
          <div className="kiga-home-nav-portal">
            <a href="https://portal-kigaltd.onrender.com" className="kiga-home-portal-btn">Members Portal</a>
          </div>

          <button 
            className="hamburger-btn"
            onClick={() => setIsNavExpanded(!isNavExpanded)}
            aria-label="Toggle menu"
          >
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
            </svg>
          </button>

          <div className={`mobile-menu ${isNavExpanded ? 'open' : ''}`}>
            <button className="close-menu" onClick={() => setIsNavExpanded(false)}>✕</button>
            <ul>
              <li><Link to="/" onClick={() => setIsNavExpanded(false)}>Home</Link></li>
              <li><Link to="/about" onClick={() => setIsNavExpanded(false)}>About</Link></li>
              <li><Link to="/classes" onClick={() => setIsNavExpanded(false)}>Classes</Link></li>
              <li><Link to="/gallery" onClick={() => setIsNavExpanded(false)}>Gallery</Link></li>
              <li><Link to="/register" onClick={() => setIsNavExpanded(false)}>Booking</Link></li>
              <li><Link to="/contact" onClick={() => setIsNavExpanded(false)}>Contact</Link></li>
              <li><Link to="/login" onClick={() => setIsNavExpanded(false)}>Members</Link></li>
            </ul>
          </div>
        </nav>

        <div className="kiga-home-hero-content">
          <div className="kiga-home-hero-text">
            <span className="kiga-home-hero-badge kiga-home-animate-slide-in">Welcome to KIGA</span>
            <h1 className="kiga-home-animate-slide-in-delay">Kigali International <span>Gymnastics Academy</span></h1>
            <p className="kiga-home-animate-slide-in-delay-2">We believe in the power of discipline, creativity, and perseverance. Founded with a passion for acrobatics and gymnastics arts, our academy is dedicated to training and inspiring the next generation of gymnasts and young athletes.</p>
            <Link to="/classes" className="kiga-home-cta-button kiga-home-animate-slide-in-delay-3">Find Classes</Link>
          </div>
        </div>

        <div className="kiga-home-social-sidebar">
        <a href="https://www.facebook.com/pascouwayezu" className='social-icon'><i className="fa-brands fa-facebook-f"></i></a>
        <a href="https://www.instagram.com/kinternationalgymnastics_kiga/ " className='social-icon'><i className="fa-brands fa-instagram"></i></a>
        <a href="https://wa.link/0pahx5" className='social-icon'><i className="fa-brands fa-whatsapp"></i></a>
        <a href="https://www.linkedin.com/in/pascal-uwayezu-b61180218/" className='social-icon'><i className="fa-brands fa-linkedin"></i></a>
        </div>

        {/* Floating animated elements */}
        <div className="kiga-home-floating-shapes">
          <div className="kiga-home-shape kiga-home-shape-1"></div>
          <div className="kiga-home-shape kiga-home-shape-2"></div>
          <div className="kiga-home-shape kiga-home-shape-3"></div>
        </div>
      </header>

      {/* Stats Counter Section */}
      <section className="kiga-home-stats-section">
        <div className="kiga-home-stats-container">
          <div className="kiga-home-stat-card">
            <div className="kiga-home-stat-number">{counterValues.students}+</div>
            <div className="kiga-home-stat-label">Happy Students</div>
          </div>
          <div className="kiga-home-stat-card">
            <div className="kiga-home-stat-number">{counterValues.classes}+</div>
            <div className="kiga-home-stat-label">Classes Offered</div>
          </div>
          <div className="kiga-home-stat-card">
            <div className="kiga-home-stat-number">{counterValues.coaches}+</div>
            <div className="kiga-home-stat-label">Expert Coaches</div>
          </div>
          <div className="kiga-home-stat-card">
            <div className="kiga-home-stat-number">{counterValues.years}+</div>
            <div className="kiga-home-stat-label">Years of Excellence</div>
          </div>
        </div>
      </section>

      {/* Gallery Strip Section */}
      <section className="kiga-home-gallery-strip">
        {['child1.jpg', 'child3.jpg', 'child4.jpg', 'child5.jpg'].map((img, index) => (
          <div key={index} className="kiga-home-gallery-item" data-aos="fade-up" data-aos-delay={index * 100}>
            <img src={`/images/Gallery/${img}`} alt={`Gymnastics ${index + 1}`} />
            <div className="kiga-home-gallery-overlay">
              <h3>Meet Our Stars</h3>
              <p>Young athletes building strength, confidence, and skills together!</p>
              <Link to="/register" className="kiga-home-join-link">Join Now →</Link>
            </div>
          </div>
        ))}
      </section>

      {/* About Section */}
      <section className="kiga-home-about-section">
        <ScrollRevealSection>
          <div className="kiga-home-about-content">
            <div className="kiga-home-about-text">
              <span className="kiga-home-section-tag">About Us</span>
              <h2>KIGALI INTERNATIONAL <span>GYMNASTICS ACADEMY</span></h2>
              <p>At Kigali International Gymnastics Academy, we believe in the power of discipline, creativity, and perseverance. Founded with a passion for acrobatics and gymnastics arts, our academy is dedicated to training and inspiring the next generation of gymnasts and young athletes. Our specialized Coach is a well-known figure in the field of Gymnastics with more than 11 years of experience. We provide a structured and supportive environment where students can develop their skills, confidence, and physical strength through Gymnastics and Acrobatics weekly classes.</p>
              <Link to="/contact" className="kiga-home-contact-link">Contact Us →</Link>
            </div>
            <div className="kiga-home-about-media">
              <div className="kiga-home-video-container">
                <iframe 
                  src="https://streamable.com/e/rt0v3k?autoplay=1&muted=1" 
                  allow="fullscreen; autoplay" 
                  allowFullScreen
                  title="KIGA Promo Video"
                />
              </div>
            </div>
          </div>
        </ScrollRevealSection>
      </section>

      {/* Parent Portal Section */}
      <section className="kiga-home-parent-section">
        <ScrollRevealSection>
          <div className="kiga-home-parent-portal-card">
            <h3>Parent Portal</h3>
            <div className="kiga-home-parent-portal-links">
              <Link to="/portal/booking">Class Schedules</Link>
              <Link to="/portal/booking">Event Schedules</Link>
              <Link to="/login">Parent Login / Register Account</Link>
            </div>
          </div>
        </ScrollRevealSection>
        
        <ScrollRevealSection>
          <div className="kiga-home-parent-info-card">
            <h3>New to Gymnastics? Try a FREE class!</h3>
            <p>K.I.G.A offers one free trial class to new members! Create an account, add students, find a suitable class and click 'Enroll' with 'Trial' enrollment type.</p>
          </div>
          <div className="kiga-home-parent-info-card">
            <h3>Already have an athlete enrolled?</h3>
            <p>Visit Parent Login and click "Forgot Password" if needed. Once logged in, you can view payment history, update payment methods, make payments, update contact information, schedule make-ups, request transfers, or drop from class.</p>
          </div>
        </ScrollRevealSection>
      </section>

      {/* Why Gymnastics Section */}
      <section className="kiga-home-why-gymnastics">
        <div className="kiga-home-why-section-header">
          <h2>Why Gymnastics, Tumbling or Acrobatics?</h2>
        </div>
        
        <div className="kiga-home-why-features-grid">
          {features.map((feature, index) => (
            <ScrollRevealSection key={index}>
              <div className="kiga-home-why-feature-card">
                <div className="kiga-home-why-feature-icon">{feature?.icon}</div>
                <h3>{feature?.title}</h3>
                <p>{feature?.title === "Encourage Self Discovery" && "With the increased demand for academic achievement, children have less time than ever to discover the amazing feats their body is capable of."}
                   {feature?.title === "Change Their Life" && "Regular socialization is paramount to a child's understanding of the needs and feelings of others, developing their ability to improvise and adjust to various social situations."}
                   {feature?.title === "Bring Out Their Best" && "Gymnastics is a total body sport utilizing functional muscle groups, increasing cardiovascular health, strength, endurance, flexibility, and mental fortitude."}
                   {feature?.title === "Help Them Meet Their Goals" && "The constant training required from gymnastics gives children the determination to see things through, even when they get hard."}
                </p>
              </div>
            </ScrollRevealSection>
          ))}
        </div>
      </section>

      {/* Tuition & Registration Section */}
      <section className="kiga-home-tuition-section">
        <div className="kiga-home-tuition-section-header">
          <h2>Booking & MemberShip Plan</h2>
        </div>
        
        <div className="kiga-home-tuition-grid">
          <ScrollRevealSection>
            <div className="kiga-home-tuition-card kiga-home-red-card">
              <img src="/images/classes-icon.png" alt="Classes" />
              <h3>Classes</h3>
              <p>Find a class that's perfect for your schedule and your child's age range. Each class is designed to support your child's physical, social, and emotional growth.</p>
              <Link to="/portal/booking" className="kiga-home-red-link">Find Your Gym's Schedules →</Link>
            </div>
          </ScrollRevealSection>
          
          <ScrollRevealSection>
            <div className="kiga-home-tuition-card kiga-home-blue-card">
              <img src="/images/membership.webp" alt="Membership" />
              <h3>Membership</h3>
              <p>Choose the membership package that fits your family best. Create healthy habits for you and your children while saving money and enjoying rewards.</p>
              <Link to="/membership" className="kiga-home-blue-link">Learn More →</Link>
            </div>
          </ScrollRevealSection>
          
          <ScrollRevealSection>
            <div className="kiga-home-tuition-card kiga-home-green-card">
              <img src="/images/parties.webp" alt="Parties" />
              <h3>Parties & More</h3>
              <p>Our birthday parties are simply AWESOME. Our camps are educational and fun. Plus, our Parent Survival Night gives you the break you deserve.</p>
              <Link to="#" className="kiga-home-green-link">Discover More →</Link>
            </div>
          </ScrollRevealSection>
        </div>
      </section>

{/* Classes Offered Section */}
<section className="kiga-home-classes-section">
  <div className="kiga-home-classes-section-header">
    <h2>Our Classes</h2>
  </div>

  <div className="kiga-home-classes-offered-grid">
    {contentData?.allClass?.map((item) => (
      <ScrollRevealSection key={item?._id || item?.id}>
        <div className="kiga-home-classes-offered-class-card">
          <div className="kiga-home-classes-offered-class-card-image">
            <img 
              src={item?.image?.secure_url} 
              alt={item?.name || "Gymnastics Class"} 
              loading="lazy" 
            />
            <div className="kiga-home-classes-offered-class-card-age">
              Ages {item?.age}
            </div>
          </div>

          <div className="kiga-home-classes-offered-class-card-content">
            <h3>{item?.name}</h3>
            
            <p>
              {item?.description 
                ? item.description.length > 100 
                  ? `${item.description.slice(0, 100)}...` 
                  : item.description 
                : "No description available."}
            </p>

            <div className="kiga-home-classes-offered-class-card-footer">
              <span className="kiga-home-classes-offered-class-card-level">
                {getClassLevel(item?.name)}
              </span>
              <Link to="/classes" className="kiga-home-classes-offered-class-card-learn-more">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </ScrollRevealSection>
    ))}
  </div>
</section>
 {/* Trainers Section */}
      <section className="kiga-home-trainers-section">
        <div className="kiga-home-trainers-section-header">
          <h2>Board Members And Coachers</h2>  
        </div>  
        <div className="kiga-home-trainers-grid">
          {contentData?.allCoach?.map((trainer, index) => (
            <div className="kiga-home-trainer-card" key={index}>
              <div className="kiga-home-trainer-image">
                <img src={trainer?.image?.secure_url} alt={trainer?.name} />
              </div>
              <div className="kiga-home-trainer-info">
                <h3>{trainer?.name}</h3>
                <p className="kiga-home-trainer-experience">{trainer?.roles}</p>
                <p className="kiga-home-trainer-experience">{trainer?.experience}+ Years Experience</p>
                <p className="kiga-home-trainer-phone">{trainer?.mobile}</p>
                <div className="kiga-home-trainer-social">
                  {trainer?.social?.map((social, idx) => (
                    <a key={idx} href="/" className={`kiga-home-trainer-social-${social?.name}`}>
                      <i className={social?.icons}></i>
                    </a>
                  ))}
                </div>
                <p className="kiga-home-trainer-bio">{trainer?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* Philosophy Section with GIF Animation */}
      <section className="kiga-home-philosophy-section">
        <div className="kiga-home-philosophy-background-gif">
          <div className="kiga-home-philosophy-background-gif-overlay"></div>
          <img src="/images/gifs/gymnastics-bg.gif" alt="Gymnastics Animation" className="bg-gif" />
        </div>
        
        <div className="kiga-home-philosophy-content">
          <div className="kiga-home-philosophy-text">
            <h2 className="kiga-home-philosophy-title">At Kigali International Gymnastics Academy</h2>
            <div className="kiga-home-philosophy-animated-text">
              <p className="kiga-home-animated-sentence">we believe that gymnastics is both a sport and an art</p>
              <p className="kiga-home-animated-sentence kiga-home-delay-1">an inspiring path to discipline, self-expression, and personal growth</p>
              <p className="kiga-home-animated-sentence kiga-home-delay-2">Our philosophy combines structured coaching with creative exploration</p>
              <p className="kiga-home-animated-sentence kiga-home-delay-3">allowing each child to develop confidence, strength, and focus</p>
              <p className="kiga-home-animated-sentence kiga-home-delay-4">in a supportive and inclusive environment</p>
            </div>
            
            <div className="kiga-home-philosophy-gif-grid">
              <div className="kiga-home-philosophy-gif-item">
                <img src="/images/gifs/kids-acrobatics.gif" alt="Kids doing acrobatics" />
                <span>Acrobatics</span>
              </div>
              <div className="kiga-home-philosophy-gif-item">
                <img src="/images/gifs/kids-balance.gif" alt="Kids practicing balance" />
                <span>Balance Training</span>
              </div>
              <div className="kiga-home-philosophy-gif-item">
                <img src="/images/gifs/kids-tumbling.gif" alt="Kids tumbling" />
                <span>Tumbling Skills</span>
              </div>
              <div className="kiga-home-philosophy-gif-item">
                <img src="/images/gifs/kids-flexibility.gif" alt="Kids flexibility training" />
                <span>Flexibility</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="philosophy-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" />
          </svg>
        </div>
      </section>

     <section className='kiga-home-blogs-section'>
      <div className="kiga-home-blogs-section-header">
       <h2>Our News & Events</h2>
      </div>
      <div className="kiga-home-blogs-main-card">
        {
          allData?.map((el,index)=>(
        <div className="kiga-blogs-main-section-card" key={index}>
        {/* Image */}

        <div className="kiga-blogs-main-section-card-image">
          <Link to={`/news/details/${el?._id}`}>
            <img src={el?.image?.secure_url} alt={el?.title} />
          </Link>
            {el?.category && (
            <span className="blog-card-category">{el?.category}</span>
            )}
        </div>
        {/* Content */}
        <div className="kiga-blogs-main-section-card-content">
            <h3 className="kiga-blogs-main-section-card-title">{el?.title}</h3>
            {/* Author & Meta */}
            <div className="kiga-blogs-main-section-card-meta">
            <div className="kiga-blogs-main-section-card-author">
                <img src={el?.author?.avatar} alt={el?.author?.name} />
                <div>
                <p className="kiga-blogs-main-section-card-author-name">{el?.author?.name}</p>
                <p className="kiga-blogs-main-section-card-post-date">{el?.date}</p>
                </div>
            </div>

            {el?.readTime && (
                <span className="read-time">{el?.readTime}</span>
            )}
            </div>
            <p className="kiga-blogs-main-section-card-excerpt">{el?.content}</p>
        </div>

        {/* Footer */}
        <div className="kiga-blogs-main-section-card-footer">
            <a href={el?.slug} className="kiga-blogs-main-section-card-read-more">
            Read More →
            </a>
        </div>
        </div>
          ))
        }
      </div>
     </section>
  {/* Testimonials Section */}
      <section className="kiga-home-testimonials-section">
        <div className="kiga-home-testimonials-section-header">
          <h2>What People Are Saying</h2>
          <p>Parents, School Principals, and More</p>
        </div>
        
        <div className="kiga-home-testimonials-grid">
          {comments.map((comment, index) => (
            <div className="kiga-home-testimonial-card" key={index}>
              <p className="kiga-home-testimonial-text">"{comment?.text}"</p>
              <p className="kiga-home-testimonial-author">{comment?.author}</p>
              <p className="kiga-home-testimonial-role">{comment?.role}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  </>
  );
};

export default Home;